import { render, staticRenderFns } from "./trainingHeaderAdmin.vue?vue&type=template&id=d8ef314a&scoped=true&"
import script from "./trainingHeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./trainingHeaderAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ef314a",
  null
  
)

export default component.exports